var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "panel"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("订单记录")]), _c('div', {
    staticClass: "comment-list",
    attrs: {
      "id": "comment-list"
    }
  }, _vm._l(_vm.salesOrderCommentList, function (com, index) {
    return _c('div', {
      key: index,
      staticClass: "comment"
    }, [_c('h5', {
      staticClass: "c_name"
    }, [_vm._v(" " + _vm._s(com.createdBy.name) + " "), _c('Time', {
      staticClass: "c_created_at",
      attrs: {
        "time": com.createdAt
      }
    })], 1), _c('span', {
      staticClass: "c_content"
    }, [_vm._v(_vm._s(com.content))])]);
  }), 0), _c('div', {
    staticClass: "input-block"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.inputText,
      expression: "inputText"
    }],
    staticClass: "ivu-input textarea-block",
    attrs: {
      "wrap": "soft",
      "autocomplete": "off",
      "spellcheck": "false",
      "placeholder": "输入评论...",
      "rows": "3"
    },
    domProps: {
      "value": _vm.inputText
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.inputText = $event.target.value;
      }
    }
  }), _c('Button', {
    staticStyle: {
      "float": "right",
      "margin-right": "8px"
    },
    attrs: {
      "disabled": _vm.inputText === null || _vm.inputText.trim() === '',
      "size": "small"
    },
    on: {
      "click": _vm.sendComment
    }
  }, [_vm._v("发送")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }